<template>
  <v-card>
 <v-card-title>
      
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
         :search="search"
            :items="items"
            :headers="headers"
        
    >
      <template v-slot:item.srno="{ item }">
        <span class="table-users-srno">{{item.id}}</span>
      </template>

      <template v-slot:item.name="{ item }">
        <span class="table-users-name">{{item.name}}</span>
      </template>

      <template v-slot:item.email="{ item }">
        <!-- <span class="table-users-name">{{item.email}}</span> -->
        <span class="table-users-name">{{ (item.user_role != 'Student') ? item.email : (item.student_detail) ? item.student_detail.gaurdian_email : "Student Not Exist"  }}</span>
      </template>

      <template v-slot:item.status="{ item }">
        <span class="table-users-status st-success" v-if="item.status == 'active'">Active</span>
        <span class="table-users-status st-error" v-else>Inactive</span>
      </template>

      <template v-slot:item.action="{ item }">
        <router-link class="profile-link" active-class :exact="true" :to="{name: 'EditUser',params:{id:item.id}}">
          <v-icon color="success">mdi-file-edit</v-icon>
        </router-link>
        <v-icon v-if="item.user_role!='Admin'" color="red" @click="confirmDelete(item)" @click.stop="dialog = true">mdi-delete</v-icon>

      </template>
    </v-data-table>
    <!-- <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Users
        <span
          :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{count}}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="totalPages"></v-pagination>
    </div> -->
      <delete-dialog
      @success="deleteTutor"
      :confirm-loading="deleteConfirmLoading"
      @closeDialog="cancelDelete"
      :dialog="delete_dialog"
      title="Tutor"
    ></delete-dialog>
  </v-card>
</template>

<script>
import DeleteDialog from "../Dialogs/DeleteDialog";
import DataTableMixin from "../../mixins/dataTable";
import DeleteRow from "../../mixins/deleteRow";
export default {
  name: "UserTable",
  components: {
    DeleteDialog,
  },
  mixins: [
    DataTableMixin,
    DeleteRow
  ],
  data() {
    return {
      search : '',
      delete_dialog: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      toggleSmall: true,
      headers: [
        { text: "SrNo.", sortable: true, value: "id" },
        { text: "Name", value: "name", sortable: true },
        { text: "Email", value: "email", sortable: false },
        { text: "Username", value: "username", sortable: false },
        { text: "Role", value: "user_role", sortable: false },
        { text: "Status", value: "status", sortable: false },
        { text: "Action", value: "action", sortable: false }
      ],
      items: []
    };
  },

  methods: {
     deleteTutor() {
      //  console.log(this.current_row.user_name)
      this.deleteConfirmLoading = true;
      axios
        .delete('delete/user' +'/' + this.current_row.id)
        .then((response) => {
          // console.log(response);
          this.getItems();
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
        })
        .catch((error) => {});
    },
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },
    extraQueryParams(){
      return {
        ...this.formQueryParams(),
        is_staff:true
      }
    },
    getItems() {
      axios.get(apiRoutes.users.url, {params: this.extraQueryParams()}).then(response => {
        console.log(response)
        // this.formalizeTable(response.data)
        this.items = response.data.response
      })
    }
  },
  mounted() {
    this.getItems()
  }
};
</script>

<style lang='scss'>
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}
.table-users {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }
  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }
  &-email {
    font: 400 12px/13px Lato;
    color: #172b4d4d;
  }
  &-time {
    display: block;
    font: 400 11px/10px Lato;
    color: #0e0edff7;
  }
  &-days {
    font: 400 10px/15px Lato;
    color: #172b4db3;
  }
  &-status {
    font: 500 14px/13px Gotham;
    &.st-success {
      color: #129b11;
    }
    &.st-error {
      color: #e41b1bf7;
    }
  }
  &-tutor {
    font: 500 13.5px Gotham;
    color: #529b11;
  }
}

.v-btn.v-size--default {
  font-size: 12px;
  text-transform: none;
}
</style>